// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';


function makeDisplayNeighborhood(__typename, __id, id, label) {
  return {
    __typename: __typename,
    __id: __id,
    id: id,
    label: label
  };
}

function makeCoordinates(lat, lon) {
  return {
    lat: lat,
    lon: lon
  };
}

function makeStandardizedAddress(address, zip, city, state) {
  return {
    address: address,
    zip: zip,
    city: city,
    state: state
  };
}

function makeValidatedData(displayNeighborhoods, coordinates, standardizedAddress) {
  return {
    displayNeighborhoods: displayNeighborhoods,
    coordinates: coordinates,
    standardizedAddress: standardizedAddress
  };
}

function toGeocodingData(coordinates, standardizedAddress) {
  if (coordinates !== undefined && standardizedAddress !== undefined) {
    return {
      lat: coordinates.lat,
      lon: coordinates.lon,
      standardizedAddress: standardizedAddress.address,
      standardizedZip: standardizedAddress.zip,
      standardizedCity: standardizedAddress.city,
      standardizedState: standardizedAddress.state
    };
  }
}

exports.makeDisplayNeighborhood = makeDisplayNeighborhood;
exports.makeCoordinates = makeCoordinates;
exports.makeStandardizedAddress = makeStandardizedAddress;
exports.makeValidatedData = makeValidatedData;
exports.toGeocodingData = toGeocodingData;
/* No side effect */
